export const RISK_TOLERANCE_OPTIONS = [
    {value: "LOW", name: "Low Risk"},
    {value: "MODERATE", name: "Moderate Risk"},
    {value: "SPECULATION", name: "Speculative Risk"},
    {value: "HIGH", name: "High Risk"},
]